























































































































































































































































































































































































































































































































































































































































































































































































































































































import VIcon from '../components/VIcon.vue';
import VBaseInlineInput from '../components/VBaseInlineInput.vue';
import VSwitch from '../components/VSwitch.vue';
import VPaginator from '../components/VPaginator.vue';
import VCheckbox from '../components/VCheckbox.vue';
import VColorPicker from '../components/VColorPicker.vue';
import VDataTable from '../components/VDataTable.vue';
import VModal from '../components/VModal.vue';
import VInlineEditor from '../components/VInlineEditor.vue';
import VInlineMultiSelect from '../components/VInlineMultiSelect.vue';
import VListGroup from '../components/VListGroup.vue';
import VMultiSelect from '../components/VMultiSelect.vue';
import VContentLoading from '../components/VContentLoading.vue';
import VEntryList from '../components/VEntryList.vue';
import VEntrySearch from '../components/VEntrySearch.vue';
import VSelect, { VSelectOption } from '../components/VSelect.vue';
import VSwitchButton from '../components/VSwitchButton.vue';
import VMultiSwitcher from '../components/VMultiSwitcher.vue';
import VNumberPicker from '../components/VNumberPicker.vue';
import VLetterIcon from '../components/VLetterIcon.vue';
import VTimePicker from '../components/VTimePicker.vue';
import VTimeSlotPicker from '../components/VTimeSlotPicker.vue';
import VDatePicker from '../components/VDatePicker.vue';
import VMultiLevelSelect from '../components/VMultiLevelSelect.vue';
import Entry from '../models/Entry';
import EntryGroupItem from '../models/EntryGroupItem';
import VComparisonGroupSelect from '../components/VComparisonGroupSelect.vue';
import VAudio from '../components/VAudio.vue';
import VVideo from '../components/VVideo.vue';
import VModalVideo from '../components/VModalVideo.vue';
import VSplitDateSelect from '@/components/VSplitDateSelect.vue';

import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    VIcon,
    VSwitch,
    VPaginator,
    VCheckbox,
    VColorPicker,
    VDataTable,
    VInlineEditor,
    VModal,
    VBaseInlineInput,
    VInlineMultiSelect,
    VListGroup,
    VMultiSelect,
    VContentLoading,
    VEntryList,
    VEntrySearch,
    VSelect,
    VSwitchButton,
    VMultiSwitcher,
    VNumberPicker,
    VLetterIcon,
    VTimePicker,
    VTimeSlotPicker,
    VDatePicker,
    VMultiLevelSelect,
    VComparisonGroupSelect,
    VSplitDateSelect,
    VAudio,
    VVideo,
    VModalVideo
  }
})
export default class Styleguide extends Vue {
  vswitchVariable = true;

  vcheckboxVariable = true;

  meta = {
    previousPage: 1,
    nextPage: 2,
    lastPage: 3,
    currentPage: 1,
    totalPages: 4
  };

  DPNow = new Date();

  IVvalue = 'Test';
  IVplaceholder = 'Component Label';

  IVNested = {
    test: 'test',
    nested: 'test 2'
  };

  IVKeys = ['test', 'nested'];

  color = '#ff0000';
  colors = ['#0000ff', '#ff0000', '#00ff00'];

  DTcolumns = [
    {
      sortable: false,
      name: 'test',
      label: 'Test'
    }
  ];

  DTScolumns = [
    {
      sortable: true,
      name: 'test',
      label: 'Test'
    }
  ];

  DTvalues = [{ test: '1' }, { test: '2' }];

  IMSvalues = [];
  IMSoptions = [
    {
      id: '1',
      name: 'Item 1',
      group: 'Group 1'
    },
    {
      id: '2',
      name: 'Item 2',
      group: 'Group 1'
    },
    {
      id: '3',
      name: 'Item 3',
      group: 'Group 2'
    }
  ];

  Vitems = [
    {
      id: '1',
      label: 'hi'
    },
    {
      id: '2',
      label: 'ciao'
    }
  ];

  VselectItems: Array<VSelectOption> = [
    {
      id: '1',
      text: 'Text 1',
      editable: false
    },
    {
      id: '2',
      text: 'Text 2',
      editable: false
    },
    {
      id: '3',
      text: 'Text 3',
      editable: true
    },
    {
      id: '4',
      text: 'Text 4',
      editable: true
    },
    {
      id: '5',
      text: 'Text 5',
      editable: true
    }
  ];

  msoptions = [
    {
      id: '1',
      text: 'Text 1',
      disabled: false
    },
    {
      id: '2',
      text: 'Text 2',
      disabled: true
    },
    {
      id: '3',
      text: 'Text 3',
      disabled: false
    }
  ];

  option = {};

  mlsOptions = [
    {
      id: '1',
      text: 'Text 1',
      children: [
        {
          id: '4',
          text: 'Text 4'
        },
        {
          id: '5',
          text: 'Text 5'
        }
      ]
    },
    {
      id: '2',
      text: 'Text 2'
    },
    {
      id: '3',
      text: 'Text 3'
    }
  ];

  palette = {
    1: '#33C8FF',
    2: '#FFE36F',
    3: '#5EE96B',
    4: '#F75151',
    5: '#B03EE2',
    6: '#4B5EEF',
    7: '#FF9D00',
    8: '#11D9D2',
    9: '#FD7AD5',
    10: '#8A4DFF',
    11: '#A1CFF7',
    12: '#E2EA2A',
    13: '#C4F0C8',
    14: '#C41854',
    15: '#E2BFF0',
    16: '#468793',
    17: '#EACB8B',
    18: '#06C482',
    19: '#FCBEBE',
    20: '#A0559D'
  };

  gItems: EntryGroupItem[] = [];
  private listGroupSelectedItem = { id: null, label: null };

  public loadGroups(payload: any): Promise<EntryGroupItem[]> {
    return Promise.resolve(this.gItems);
  }

  public createGroup(group: EntryGroupItem): Promise<EntryGroupItem> {
    group.id = this.gItems.length;
    this.gItems.push(group);
    return Promise.resolve(group);
  }

  public addEntryToGroup(entry: Entry, group: EntryGroupItem): Promise<void> {
    if (group.entries) {
      group.entries.push(entry);
    } else {
      group.entries = [entry];
    }
    return Promise.resolve();
  }

  public removeEntryFromGroup(
    entry: Entry,
    group: EntryGroupItem
  ): Promise<void> {
    if (group.entries) {
      const idx = group.entries.indexOf(entry);
      group.entries = group.entries.splice(idx, 1);
    }
    return Promise.resolve();
  }

  public async loadItems(term: string) {
    return Promise.resolve([...this.IMSoptions]);
  }

  public dpOpen() {
    const dp = this.$refs.datePicker as any;
    dp.show();
  }

  public mdOpen() {
    const modal = this.$refs.modal as any;
    modal.show();
  }

  openVideo(which: string) {
    const modalVideo = this.$refs[which] as any;
    modalVideo.show();
  }

  onListGroupItemSelected(value: any) {
    this.listGroupSelectedItem = value;
  }
}
